import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';

import { ActivityService } from '../../services/activity.service';

@Component({
  selector: 'app-activity',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './activity.component.html',
  styleUrl: './activity.component.scss',
})
export class ActivityComponent {
  private fb = inject(FormBuilder);
  private apiService = inject(ActivityService);
  private successMessageTimeout?: ReturnType<typeof setTimeout>;

  activityForm: FormGroup;
  activityTypes = ['mandatory', 'optional', 'specific'];

  showSuccessMessage = false;
  isCreating = false;

  // Controla si el administrador quiere establecer
  // un límite de participantes.
  hasParticipantLimit = false;

  constructor() {
    this.activityForm = this.fb.group({
      title: ['', Validators.required],
      description: [''],
      type: ['', Validators.required],
      startDate: [new Date()],
      dueDate: [''],
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
      valueInHours: [0, [Validators.required, Validators.min(0)]],
      comments: [''],

      // null = sin límite
      // número = máximo de participantes
      maxParticipants: [null],
    });
  }

  onParticipantLimitChange(): void {
    if (this.hasParticipantLimit) {
      // Si se activa el límite, hacemos obligatorio
      // introducir al menos 1 participante.
      this.activityForm
        .get('maxParticipants')
        ?.setValidators([
          Validators.required,
          Validators.min(1),
          Validators.pattern(/^[0-9]+$/),
        ]);
    } else {
      // Si no hay límite, enviamos null al backend.
      this.activityForm.get('maxParticipants')?.clearValidators();
      this.activityForm.get('maxParticipants')?.setValue(null);
    }

    this.activityForm.get('maxParticipants')?.updateValueAndValidity();
  }

  async onSubmit(): Promise<void> {
    console.log('FORMULARIO ACTIVIDAD:', this.activityForm.value);
    console.log('FORMULARIO VÁLIDO:', this.activityForm.valid);

    if (!this.activityForm.valid) {
      this.activityForm.markAllAsTouched();
      console.error('El formulario de actividad no es válido.');
      return;
    }

    if (this.isCreating) {
      return;
    }

    try {
      this.isCreating = true;
      this.showSuccessMessage = false;

      const data = await this.apiService.newActivity(
        this.activityForm.value,
      );

      console.log('ACTIVIDAD CREADA:', data);

      this.activityForm.reset({
        title: '',
        description: '',
        type: '',
        startDate: new Date(),
        dueDate: '',
        startTime: '',
        endTime: '',
        valueInHours: 0,
        comments: '',
        maxParticipants: null,
      });

      // Regresamos la opción a "Sin límite"
      // después de crear la actividad.
      this.hasParticipantLimit = false;

      if (this.successMessageTimeout) {
        clearTimeout(this.successMessageTimeout);
      }

      this.showSuccessMessage = true;

      this.successMessageTimeout = setTimeout(() => {
        this.showSuccessMessage = false;
      }, 4000);
    } catch (error: unknown) {
      console.error('ERROR CREANDO ACTIVIDAD:', error);
    } finally {
      this.isCreating = false;
    }
  }
}